import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { isFetchBaseQueryError } from 'lib-shared-auth';

export type SettingsAgentsRoleTab = 'permissions' | 'agents';

type DeleteCustomRoleErrorWithReason = FetchBaseQueryError & {
  data: {
    title: string;
  };
};

export function isDeleteCustomRoleErrorWithReason(
  error: unknown,
): error is DeleteCustomRoleErrorWithReason {
  if (isFetchBaseQueryError(error)) {
    const errorData = error.data;

    return (
      typeof errorData === 'object' &&
      errorData != null &&
      'title' in errorData &&
      typeof errorData.title === 'string'
    );
  }
  return false;
}
